var _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import JSONSerializer from '@ember-data/serializer/json';
import { underscore } from '@ember/string';
import { inject as service } from '@ember/service';
let CatalogFragment = (_class = class CatalogFragment extends JSONSerializer {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "catalog", _descriptor, this);
  }
  keyForAttribute(attr) {
    return underscore(attr);
  }
  serializeAttribute(snapshot, json, key, attribute) {
    // Ember data coerces undefined values to null, but some APIs treat
    // those values differently.
    if (snapshot.attr(key) === undefined) {
      return;
    }

    // Only serialize enums to their proto equivalent when crafting RPC requests.
    // Consumers can set `serializeForRpc` on the catalog service when proto enum serialization is desired.
    if (this.catalog.serializeForRpc && attribute.options?.protoEnum) {
      const protoEnum = attribute.options.protoEnum;
      const value = snapshot.attr(key);
      const serializedValue = Array.isArray(value) ? value.map(obj => protoEnum[obj]) : protoEnum[value];

      // Directly modifying the json param is how Ember's own JSON serializer works

      json[this.keyForAttribute(key)] = serializedValue;
    } else {
      super.serializeAttribute(snapshot, json, key, attribute);
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "catalog", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
export { CatalogFragment as default };